import { teacherData } from './teacherData.js';
import { schoolSecretaryData } from './schoolSecretaryData.js';
import { guidanceCounselorData } from './guidanceCounselorData.js';
import { labSpecialistData } from './labSpecialistData.js';
import { schoolPsychologistData } from './schoolPsychologistData.js';
import { socialWorkerData } from './socialWorkerData.js';
import { labTechData } from './labTechData.js';
import { paraprofessionalsData } from './paraprofessionalsData.js';
import { adultEdData } from './adultEdData.js';

export const appData = [
    {
        id: "home",
        jobTitle: 'default',
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/money.png"),
                alt: "Money Icon",
                width: "112px"
            },
            {
                type: "Title",
                content: "UFT Salary Checkup",
            },
            {
                type: "Content",
                content: "Make sure you’re getting all the pay you deserve, and find out how to increase your earning power."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Check my pay for errors", 
                        linkId: "check-my-pay-for-errors",
                        size: "large"
                    },
                    {
                        label: "See how much I'll be earning in the future", 
                        linkId: "see-how-much-i-will-be-earning-in-the-future",
                        size: "large"
                    }
                ]
            }
        ]
    },
    {
        id: 'see-how-much-i-will-be-earning-in-the-future',
        jobTitle: 'default',
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/binoculars.png"),
                alt: "Binoculars Icon",
                width: "102px"
            },
            {
                type: "Title",
                content: "Coming soon."
            },
            {
                type: "Content",
                content: "Meantime, you can check your pay for errors."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Check my pay for errors", 
                        linkId: "check-my-pay-for-errors",
                    }
                ]
            }
        ]
    },
    {
        id: 'check-my-pay-for-errors',
        jobTitle: 'default',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Helpful tip:",
                underline: true
            },
            {
                type: "Content",
                content: "We recommend using this tool on your phone while being logged into the NYC DOE payroll portal on your computer (a two-screen experience)."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue", 
                        linkId: "job-title",
                    }
                ]
            },
            {
                type: "External Text Link",
                label: "Open the NYC DOE payroll portal in a new window",
                link: "https://payrollportal.nycboe.net"
            },
        ]
    },
    {
        id: 'job-title',
        jobTitle: 'default',
        components: [
            {
                type: "Sub Title",
                content: "What’s your job title?"
            },
            {
                type: "Dropdown",
                id: "job-title",
                content: [
                    {
                        label: "Select",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "Teacher",
                        value: "teacher"
                    },
                    {
                        label: "Paraprofessional",
                        value: "paraprofessionals"
                    },
                    {
                        label: "Adult Education Teacher",
                        value: "adult-education-teacher"
                    },
                    {
                        label: "Guidance Counselor",
                        value: "guidance-counselor"
                    },
                    {
                        label: "Lab Specialist",
                        value: "lab-specialist"
                    },
                    {
                        label: "Lab Tech",
                        value: "lab-tech"
                    },
                    {
                        label: "School Psychologist",
                        value: "school-psychologist"
                    },
                    {
                        label: "School Secretary",
                        value: "school-secretary"
                    },
                    {
                        label: "Social Worker",
                        value: "social-worker"
                    }
                ]
            },
            {
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "hello-there",
                        hidden: true,
                        variableId: "job-title"
                    }
                ]
            }
        ]
    },
    ...teacherData,
    ...schoolSecretaryData,
    ...guidanceCounselorData,
    ...labSpecialistData,
    ...schoolPsychologistData,
    ...socialWorkerData,
    ...labTechData,
    ...paraprofessionalsData,
    ...adultEdData
]